import { render, staticRenderFns } from "./PurchasePlanMgmt.vue?vue&type=template&id=254396a7"
import script from "./PurchasePlanMgmt.vue?vue&type=script&lang=js"
export * from "./PurchasePlanMgmt.vue?vue&type=script&lang=js"
import style0 from "./PurchasePlanMgmt.vue?vue&type=style&index=0&id=254396a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports